<template>
  <div class="episode-card__img-box">
    <component
      :is="lazyComponent"
      :src="coverUrl"
      crossorigin="anonymous"
      class="episode-card__img"
      alt=""
    />
  </div>
</template>

<script setup lang="ts">
import { IS_PRERENDERING } from '@/init/settings'
import { EpisodeListItem } from '@/models/interfaces'
import { computed } from 'vue'
import LazyImage from './LazyImage.vue'
import PublicImage from './PublicImage.vue'

const props = defineProps<{
  doc: EpisodeListItem
}>()

/* Lazy load is disabled for static pages.

  Note: When accessing the static page locally, we will not see any cover_images
  unless we've build them using the build.sh script.

*/

const lazyComponent = computed(() => {
  return !IS_PRERENDERING ? LazyImage : PublicImage
})
const coverUrl = 'https:' + props.doc.cover_image
</script>

<style lang="scss" scoped></style>
